














import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
import myTable from '../../components/table/my-table.vue'
import {GetHDInfo} from '../../api/realTime'
import dialysisInfoDetail from './dialysisInfoDetail.vue'
@Component({
    components: {myTable,dialysisInfoDetail}
})
export default class extends AbpBase {
    @Prop({type:Number}) id:any;
    created(){
        this.getData()
    }
    get height(){
        return window.innerHeight-220
    }
    async getData(){
        let res = await GetHDInfo({patientId:this.id})
        this.list = res.data
    }
    detailShow = false
    detailData = {}
    list = []
    columns = [
        {title:'透析时间',key:'dialysisDate'},
        {title:'透析模式',key:'dialysisModel'},
        {title:'治疗医院',key:'tenantName'},
        {
            title:'操作',
            width:80,
            render:(h:any,p:any)=>{
               return h('span',{
                    style:{
                        color:'rgb(64, 158, 255)',
                        cursor: 'pointer',
                    },
                    on:{
                        'click':()=>{
                            this.detail(p.row)
                        }
                    }
                },'详情')
            }
        },
    ]
    detail(row:any){
        this.detailShow = true
        this.detailData = row
    }
}
